import React from "react";
import ReggoraAppraisalScreen from "./ReggoraAppraisalScreen";
import ReggoraAppraisalOrderScreen from "./ReggoraAppraisalOrderScreen";
import Screen from "../../components/layout/Screen";
import { Navigate, Route, Routes } from "react-router-dom";
import ToggleNavigation from "../../components/navigation/ToggleNavigation";
import ToggleRouterTabSwitcher from "../../components/navigation/ToggleRouterTabSwitcher";

const ExternalOrdersScreen = ({ children }) => {
  return (
    <Screen>
      <ToggleRouterTabSwitcher
        tabs={[
          { label: "Appraisal Order View 1", to: "/orders/appraisal1" },
          { label: "Appraisal Order View 2 ", to: "/orders/appraisal2" },
        ]}
      />
      <Routes>
        {/* <Route path="/" element={<ReggoraAppraisalScreen />} /> */}
        <Route path="/appraisal1" element={<ReggoraAppraisalScreen />} />
        <Route path="/appraisal2" element={<ReggoraAppraisalOrderScreen />} />
        <Route
          path="/*"
          element={<Navigate to="/orders/appraisal1" replace />}
        />
      </Routes>
    </Screen>
  );
  // return <ReggoraAppraisalScreen />;
};

export default ExternalOrdersScreen;
